import { supabase } from '@/integrations/supabase/client';

/**
 * Syncs profile data to auth.users.raw_user_meta_data so metadata stays
 * consistent with the source-of-truth profile tables (clients / practitioners).
 * This is fire-and-forget — failures are logged but never block the caller.
 */
export async function syncAuthMetadata(fields: {
  first_name?: string | null;
  last_name?: string | null;
  user_type?: string | null;
}) {
  try {
    const payload: Record<string, string> = {};
    if (fields.first_name !== undefined) payload.first_name = fields.first_name ?? '';
    if (fields.last_name !== undefined) payload.last_name = fields.last_name ?? '';
    if (fields.user_type !== undefined) payload.user_type = fields.user_type ?? '';

    if (Object.keys(payload).length === 0) return;

    const { error } = await supabase.auth.updateUser({ data: payload });
    if (error) {
      console.warn('[syncAuthMetadata] Failed to sync:', error.message);
    }
  } catch (err) {
    console.warn('[syncAuthMetadata] Unexpected error:', err);
  }
}
